import { useCallback } from 'react'
import { useAuth } from '../contexts/AuthContext'
import config from './config'

export const useApi = () => {
  const { token } = useAuth()

  const fetchWithAuth = useCallback(async (endpoint: string, options: RequestInit = {}) => {
    if (!token) {
      throw new Error('No authentication token available');
    }

    const headers = new Headers(options.headers)
    headers.set('Authorization', `Bearer ${token}`)

    const url = endpoint.startsWith('http') ? endpoint : `${config.apiUrl}${endpoint}`

    const response = await fetch(url, {
      ...options,
      headers,
      credentials: 'include',
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return response
  }, [token])

  return { fetchWithAuth }
}

export const getEmailTemplate = async (fetchWithAuth: (url: string, options?: RequestInit) => Promise<Response>, id: number) => {
  try {
    const response = await fetchWithAuth(`/admin/email-templates/${id}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      return response.json();
    } else {
      throw new Error("Oops, we haven't got JSON!");
    }
  } catch (error) {
    console.error('Error fetching email template:', error);
    throw error;
  }
};

export const updateEmailTemplate = async (fetchWithAuth: (url: string, options?: RequestInit) => Promise<Response>, id: number, data: {
  name: string;
  subject: string;
  body: string;
  attachments?: any[];
}) => {
  const response = await fetchWithAuth(`/admin/email-templates/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error('Failed to update email template');
  }
  return response.json();
};
